/* 解决滚动穿透问题 */
import './style.css'
import getScrollBarWidth from './scrollbar-width'

/**
 * polyfill for document.scrollingElement
 * https://github.com/yangg/scrolling-element
 */
function polyfillScrollingElement() {
  if (document.scrollingElement) {
    return
  }
  let element = null
  function scrollingElement() {
    if (element) {
      return element
    } else if (document.body.scrollTop) {
      // speed up if scrollTop > 0
      return (element = document.body)
    }
    const iframe = document.createElement('iframe')
    iframe.style.height = '1px'
    document.documentElement.appendChild(iframe)
    const doc = iframe.contentWindow.document
    doc.write('<!DOCTYPE html><div style="height:9999em">x</div>')
    doc.close()
    const isCompliant = doc.documentElement.scrollHeight > doc.body.scrollHeight
    iframe.parentNode.removeChild(iframe)
    return (element = isCompliant ? document.documentElement : document.body)
  }
  Object.defineProperty(document, 'scrollingElement', {
    get: scrollingElement
  })
}

polyfillScrollingElement()

/**
 * ModalHelper helpers resolve the modal scrolling issue on mobile devices
 * https://github.com/twbs/bootstrap/issues/15852
 * requires document.scrollingElement polyfill https://github.com/yangg/scrolling-element
 */
export const lock = (bodyCls) => {
  const reg = new RegExp(bodyCls)
  let scrollTop
  return {
    afterOpen() {
      const scrollBarWidth = getScrollBarWidth()
      scrollTop = document.scrollingElement.scrollTop
      document.body.classList.add(bodyCls)
      document.body.style.top = -scrollTop + 'px'
      document.body.style.paddingRight = scrollBarWidth + 'px'
      // console.trace('🔒locked scrolling')
    },
    beforeClose() {
      if (!reg.test(document.body.className)) return
      // scrollTop lost after set position:fixed, restore it back.
      document.body.classList.remove(bodyCls)
      document.scrollingElement.scrollTop = scrollTop
      document.body.style.paddingRight = 0 + 'px'
      // console.trace('unlock scrolling')
    }
  }
}

const modalHelper = lock('modal-open')

export default modalHelper
